import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton,
  Pagination,
  Box,
  CircularProgress,
  Typography,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { DocumentService } from '../../../services/documentsServices'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { useParams } from 'react-router-dom'
import { CancelOutlined, GetApp as GetAppIcon, Visibility } from '@mui/icons-material'
import axios from 'axios'
import { downloadBlob } from '../../../utility/fileUtil'
import { fileServices } from '../../../services/fileServices'

const GenerateDocumentsDialog = ({
  isGenerateDocumentDialogue,
  setIsGenerateDocumentDialogue,
  processTemplateId,
}) => {
  const { user } = useAuthContext()
  const { process_id: processId, activity_template_id: activityTemplateId } = useParams()

  const [generatedDoc, setGeneratedDoc] = useState([])
  const [loading, setLoading] = useState(new Set())
  const [previewLoading, setPreviewLoading] = useState(false)
  const [images, setImages] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(false)
  const NODE_BASE_URL = process.env.REACT_APP_NODE_BASE_URL
  const handlePageChange = (event, value) => {
    setCurrentPage(value)
  }

  const itemsPerPage = 1
  const totalPages = Math.ceil(images.length / itemsPerPage)

  const generateDocument = async () => {
    setIsLoading(true)
    try {
      const doc = await DocumentService.manuallyGenerateDoc(
        user,
        processId
      )
      setGeneratedDoc(doc)
    } catch (error) {
      console.error('Error generating document:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const doc = await DocumentService.getManuallyGenerateDoc(
          user,
          processId,
          activityTemplateId
        )
        setGeneratedDoc(doc)
      } catch (error) {
        console.error('Error fetching generated document:', error)
      }
    }

    fetchData()
  }, [user, processId, activityTemplateId])

  const getPreviewData = async (key) => {
    try {
      setPreviewLoading(true)

      const result = (
        await axios.get(
          `${NODE_BASE_URL}/data-entry/file/base64-images/${key}?folder=documents_for_template`,
          {
            headers: {
              Authorization: `Bearer ${user.token}`,
            },
          }
        )
      ).data

      setImages(result)
      setCurrentPage(result.length)
    } catch (e) {
      setImages([])
    }
  }
  const downloadFile = async (fileName, index) => {
    setLoading((prev) => new Set([...prev, index]))
    const result = await fileServices.downloadFile(user, fileName, 'documents_for_template')
    downloadBlob(result?.data, fileName)

    setLoading((prev) => {
      const updated = new Set(prev)
      updated.delete(index)
      return updated
    })
  }

  return (
    <>
      <Dialog
        open={isGenerateDocumentDialogue}
        onClose={() => setIsGenerateDocumentDialogue(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Manually Generate Document</DialogTitle>
        <DialogContent>
          {isLoading ? (
            <CircularProgress color="info" size={'25px'} />
          ) : generatedDoc && generatedDoc.length > 0 ? (
            generatedDoc.map((doc, index) => (
              <Box
                key={index}
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <Typography>{doc.document_template_name}</Typography>

                <span>
                  <IconButton
                    size="small"
                    onClick={() => {
                      getPreviewData(doc.key)
                    }}
                  >
                    {images == null ? (
                      <CircularProgress color="primary" size={'25px'} />
                    ) : (
                      <Visibility size="small" />
                    )}
                  </IconButton>

                  <IconButton size="small" download onClick={() => downloadFile(doc.key, index)}>
                    {loading.has(index) ? (
                      <CircularProgress color="info" size={'25px'} />
                    ) : (
                      <GetAppIcon color="info" size="small" />
                    )}
                  </IconButton>
                </span>
              </Box>
            ))
          ) : (
            <Typography variant="p">No document available</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setIsGenerateDocumentDialogue(false)}
            color="primary"
            variant="outlined"
          >
            Close
          </Button>
          <Button onClick={generateDocument} color="primary" variant="contained">
            Generate
          </Button>
        </DialogActions>
      </Dialog>
      <div>
        <Dialog
          open={previewLoading}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          onClose={() => {
            setPreviewLoading(false)
          }}
          maxWidth="xxl"
        >
          <Box sx={{ width: '100%' }}>
            {previewLoading && (
              <Box sx={{ width: '100%', position: 'sticky', top: 0 }}>
                <DialogContent>
                  {images.length === 0 ? (
                    <div>Preview not available. Click the "Download" icon to download file </div>
                  ) : (
                    <>
                      <div style={{ position: 'relative' }}>
                        {images && (
                          <img
                            style={{ width: '100%', height: 'auto' }}
                            src={images[currentPage - 1]}
                            alt="Document Preview"
                          />
                        )}
                        <div style={{ position: 'absolute', top: 0, right: 0 }}>
                          <Button
                            color="info"
                            size="small"
                            onClick={() => {
                              setPreviewLoading(false)
                            }}
                          >
                            <CancelOutlined size="small" />
                          </Button>
                        </div>
                      </div>
                      {images && (
                        <Box
                          sx={{
                            maxWidth: '800px',
                            display: 'flex',
                            justifyContent: 'center',
                            padding: '10px',
                            backgroundColor: 'white',
                            position: 'fixed',
                            bottom: '5%',
                            left: '50%',
                            transform: 'translateX(-50%)',
                          }}
                        >
                          <Pagination
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                            variant="outlined"
                            shape="rounded"
                          />
                        </Box>
                      )}
                    </>
                  )}
                </DialogContent>
              </Box>
            )}
          </Box>
        </Dialog>
      </div>
    </>
  )
}
export default GenerateDocumentsDialog
